export const environment = {
  production: false,
  apiUrl: 'https://stg-api.ei.study',
  imageStorageUrl: 'https://ei-content-media-vault-stg.s3.ap-south-1.amazonaws.com/Image/common/',
  audioStorageUrl: 'https://ei-content-media-vault-stg.s3.ap-south-1.amazonaws.com/Audio/',
  videoStorageUrl: 'https://ei-content-media-vault-stg.s3.ap-south-1.amazonaws.com/Video/',
  pbcDashboardUrl: 'https://stg-pbc-dashboard.platform-ei.study/'
};
